import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, Select } from 'antd';
import { RouteComponentProps } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getAnneeScolaire, updateAnneeScolaire, createAnneeScolaire, reset, getEcoleAnneeScolaire } from './annee-scolaire.reducer';
import { getEcole } from '../ecole/ecole.reducer';

export const AnneeScolaireModal = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const anneeScolaireEntity = useAppSelector(state => state.anneeScolaire.entity);
  const loading = useAppSelector(state => state.anneeScolaire.loading);
  const updating = useAppSelector(state => state.anneeScolaire.updating);
  const updateSuccess = useAppSelector(state => state.anneeScolaire.updateSuccess);

  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getEcoleAnneeScolaire(props.match.params.ecoleid));
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getAnneeScolaire(props.match.params.id));
    }
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/annee-scolaire/${props.match.params.ecoleid}`);
  };

  useEffect(() => {
    if (!isNew) {
      form.setFieldsValue({
        ...anneeScolaireEntity,
        dateDebut: anneeScolaireEntity.dateDebut?.split('T')[0],
        dateCloture: anneeScolaireEntity.dateCloture?.split('T')[0],
      });
    }
  }, [anneeScolaireEntity]);

  const saveAnneeScolaire = values => {
    const entity = {
      ...anneeScolaireEntity,
      ...values,
      dateDebut: values.dateDebut ? new Date(values.dateDebut).toISOString() : null,
      dateCloture: values.dateCloture ? new Date(values.dateCloture).toISOString() : null,
      ecoleId: props.match.params.ecoleid,
    };

    if (isNew) {
      dispatch(createAnneeScolaire(entity));
    } else {
      dispatch(updateAnneeScolaire(entity));
    }
    handleClose(event);
  };

  return (
    <Modal
      title={isNew ? 'Créer une année scolaire' : 'Modifier une année scolaire'}
      visible={true}
      closable={false}
      footer={null}
      centered
    >
      <Form form={form} layout="vertical" onFinish={saveAnneeScolaire}>
        <Form.Item name="nom" label="Nom de l'année scolaire" rules={[{ required: true, message: 'Nom est obligatoire' }]}>
          <Input />
        </Form.Item>
        {!isNew && (
          <Form.Item name="statutAnneeScolaire" label="Statut">
            <Select disabled>
              <Select.Option value="ACTIVE">ACTIVE</Select.Option>
              <Select.Option value="INACTIVE">INACTIVE</Select.Option>
            </Select>
          </Form.Item>
        )}

        <Form.Item>
          <Button onClick={handleClose} style={{ marginRight: 8 }}>
            Annuler
          </Button>
          <Button type="primary" htmlType="submit" loading={updating}>
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AnneeScolaireModal;
